<template>
	<a-modal
		class="g-audio-library-edit-modal"
		:visible="visible"
		title="模块编辑"
		width="730px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
		<div class="g-audio-library-edit" @click="clearSelection">
			<div class="g-audio-library-edit__actions" @click.stop>
				<span v-if="form.items.length > 1" class="g-audio-library-edit__hint">音频支持拖拽排序</span>
				<div class="g-audio-library-edit__actions-btns">
					<button type="button" class="g-audio-library-edit__batch-btn" @click="addBatch">添加一批</button>
					<button type="button" class="g-audio-library-edit__batch-btn" @click="addOne">添加一格</button>
				</div>
			</div>

			<div
				class="g-audio-library-edit__card"
				:class="{ 'is-card': form.showCard }"
				:style="previewCardStyle"
			>
				<div class="g-audio-library-edit__header">
					<span
						class="g-audio-library-edit__accent"
						:style="{ background: form.accentColor }"
					></span>
					<input
						v-model="form.title"
						type="text"
						class="g-audio-library-edit__title-input"
						:style="{ color: form.titleColor }"
						maxlength="20"
						placeholder="标题"
						@click.stop
					/>
				</div>

			<EditListSortGroup
					ref="editGrid"
					class="g-audio-library-edit__grid"
					@dragover="onSortDragOver"
				>
					<div
						v-for="(item, index) in form.items"
						:key="item.id"
						:data-sort-id="item.id"
						class="g-audio-library-edit__cell-wrap"
						:class="[{ 'is-active': selectedIndex === index }, getEditListSortItemClass(dragId, item.id, dragOverId)]"
						@click.stop
					>
						<div
							class="g-audio-library-edit__cell"
							:class="{ 'is-selected': selectedIndex === index }"
							:draggable="form.items.length > 1"
							@click="selectItem(index)"
							@dragstart="onItemDragStart(item.id)"
							@dragend="onItemDragEnd"
						>
							<div
								class="g-audio-library-edit__cover"
								:style="previewCoverStyle"
							>
								<UploadProgressPanel
									v-if="isUploading && selectedIndex === index"
									:tasks="uploadTasks"
									variant="item"
									hide-filename
								/>
								<template v-else>
									<img v-if="getCoverUrl(item)" :src="getCoverUrl(item)" alt="" />
									<i v-else class="mbm-iconfont mbm-yinpin"></i>
									<button
										type="button"
										class="g-audio-library-edit__play"
										aria-label="播放"
										@click.stop="playEditMedia(getAudioUrl(item), 'audio')"
									>
										<span class="g-audio-library-edit__triangle"></span>
									</button>
								</template>
							</div>
							<input
								v-model="item.audio.filename"
								type="text"
								class="g-audio-library-edit__name-input"
								:style="{ color: form.nameColor }"
								maxlength="40"
								placeholder="歌曲名称"
								@click.stop="selectItem(index)"
								@focus="selectItem(index)"
							/>
						</div>

						<div
							v-if="selectedIndex === index"
							class="g-audio-library-edit__panel g-audio-library-edit__panel--arrow g-audio-library-edit__panel--float"
							:class="getPanelAlignClass(index)"
							@click.stop
						>
							<div class="g-audio-library-edit__toolbar">
								<button type="button" class="g-audio-library-edit__action" @click="triggerAudioSelect">更换音频</button>
								<button type="button" class="g-audio-library-edit__action" @click="triggerCoverSelect">更换封面</button>
								<button
									type="button"
									class="g-audio-library-edit__action"
									:class="{ 'is-active': !form.showCard }"
									@click="toggleShowCard"
								>{{ form.showCard ? '隐藏卡片' : '显示卡片' }}</button>
								<button
									v-if="form.showCard"
									type="button"
									class="g-audio-library-edit__action"
									:class="{ 'is-active': activePanel === 'cardRadius' }"
									@click="togglePanel('cardRadius')"
								>卡片圆角</button>
								<button
									type="button"
									class="g-audio-library-edit__action"
									:class="{ 'is-active': activePanel === 'coverRadius' }"
									@click="togglePanel('coverRadius')"
								>音频圆角</button>
								<button
									type="button"
									class="g-audio-library-edit__action"
									:class="{ 'is-active': activePanel === 'height' }"
									@click="togglePanel('height')"
								>高度</button>
								<button
									type="button"
									class="g-audio-library-edit__action g-audio-library-edit__action--danger-text"
									:disabled="form.items.length <= 1"
									@click="deleteItem(index)"
								>删除</button>
								<div class="g-audio-library-edit__colors">
									<ColorPicker
										v-model="form.accentColor"
										title="标题装饰条颜色"
										@change="onAccentColorInput"
									/>
									<ColorPicker
										v-model="form.titleColor"
										title="标题颜色"
										@change="onTitleColorInput"
									/>
									<ColorPicker
										v-model="form.nameColor"
										title="音频名称颜色"
										@change="onNameColorInput"
									/>
								</div>
							</div>
							<div v-if="activePanel === 'height'" class="g-audio-library-edit__sub-row">
								<span class="g-audio-library-edit__sub-label">高度 (px)</span>
								<a-input-number
									v-model:value="coverSizeDraft"
									:min="1"
									:max="400"
									:precision="0"
									class="g-audio-library-edit__sub-input"
								/>
								<button type="button" class="g-audio-library-edit__sub-confirm" @click="applyCoverSize">确定</button>
								<span class="g-audio-library-edit__sub-default">默认值:{{ defaultCoverSize }}</span>
							</div>
							<div v-if="activePanel === 'cardRadius'" class="g-audio-library-edit__sub-row">
								<span class="g-audio-library-edit__sub-label">卡片圆角 (px)</span>
								<a-input-number
									v-model:value="cardRadiusDraft"
									:min="0"
									:max="100"
									:precision="0"
									class="g-audio-library-edit__sub-input"
								/>
								<button type="button" class="g-audio-library-edit__sub-confirm" @click="applyCardRadius">确定</button>
							</div>
							<div v-if="activePanel === 'coverRadius'" class="g-audio-library-edit__sub-row">
								<span class="g-audio-library-edit__sub-label">音频圆角 (px)</span>
								<a-input-number
									v-model:value="coverRadiusDraft"
									:min="0"
									:max="100"
									:precision="0"
									class="g-audio-library-edit__sub-input"
								/>
								<button type="button" class="g-audio-library-edit__sub-confirm" @click="applyCoverRadius">确定</button>
							</div>
						</div>
					</div>
				</EditListSortGroup>
			</div>
		</div>
		</div>

		<input
			ref="coverInput"
			type="file"
			accept="image/*"
			class="g-audio-library-edit__file-input"
			@change="onCoverSelect"
		/>
		<input
			ref="audioInput"
			type="file"
			accept="audio/*,.mp3,.wav,.m4a,.aac,.ogg,.flac,.wma"
			class="g-audio-library-edit__file-input"
			@change="onAudioSelect"
		/>

		<template #footer>
			<a-button @click="onCancel">取消</a-button>
			<a-button type="primary" class="g-audio-library-edit-modal__ok" :disabled="isUploading" @click="onConfirm">确定</a-button>
		</template>

		<EditMediaPlayerOverlay
			:url="editPlayingUrl"
			:kind="editPlayingKind"
			@close="stopEditMediaPlay"
		/>
	</a-modal>
</template>

<script>
	import { getSwatchBorderColor, normalizeHexColor } from '../utils/richText.js';
	import ColorPicker from './ColorPicker.vue';
	import {
		isLocalImageFile,
		MAX_LOCAL_IMAGE_SIZE,
	} from '../utils/localImage.js';
	import {
		filterValidLocalAudioList,
		isAudioFilename,
		MAX_LOCAL_AUDIO_SIZE,
	} from '../utils/localAudio.js';
	import {
		AUDIO_LIBRARY_DEFAULT_CARD_RADIUS,
		AUDIO_LIBRARY_DEFAULT_COVER_RADIUS,
		AUDIO_LIBRARY_DEFAULT_COVER_SIZE,
		AUDIO_LIBRARY_CARD_PADDING,
		createDefaultAudioLibraryItem,
		createDefaultAudioLibraryItems,
		getAudioLibraryAudioUrl,
		getAudioLibraryCoverUrl,
		getAudioLibraryCoverStyle,
		normalizeAudioLibraryData,
		replaceAudioLibraryAudio,
		replaceAudioLibraryCover,
		revokeAudioLibraryItems,
	} from '../utils/audioLibrary.js';
	import { ensureEditFloatPanelVisible, getGridPanelAlignClass } from '../utils/editPanelAlign.js';
	import editModalMediaPlay from '../mixins/editModalMediaPlay.js';
	import EditListSortGroup from './EditListSortGroup.vue';
	import EditMediaPlayerOverlay from './EditMediaPlayerOverlay.vue';
	import {
		createEditListDragState,
		getEditListSortItemClass,
		handleEditListSortDragEnd,
		handleEditListSortDragOver,
		handleEditListSortDragStart,
		resolveSelectedIndexAfterListMove,
	} from '../utils/editListDragSort.js';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';

	export default {
		name: 'GAudioLibraryEditModal',
		components: { EditListSortGroup, EditMediaPlayerOverlay, UploadProgressPanel, ColorPicker },
		mixins: [editModalMediaPlay],
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: normalizeAudioLibraryData({}),
				selectedIndex: null,
				activePanel: '',
				coverSizeDraft: AUDIO_LIBRARY_DEFAULT_COVER_SIZE,
				cardRadiusDraft: AUDIO_LIBRARY_DEFAULT_CARD_RADIUS,
				coverRadiusDraft: AUDIO_LIBRARY_DEFAULT_COVER_RADIUS,
				defaultCoverSize: AUDIO_LIBRARY_DEFAULT_COVER_SIZE,
				isUploading: false,
				uploadTasks: [],
				...createEditListDragState(),
			};
		},
		computed: {
			selectedItem() {
				return this.form.items[this.selectedIndex] || null;
			},
			previewCoverStyle() {
				return getAudioLibraryCoverStyle(this.form);
			},
			previewCardStyle() {
				if (!this.form.showCard) {
					return {};
				}
				return {
					borderRadius: `${this.form.cardBorderRadius}px`,
					padding: `${AUDIO_LIBRARY_CARD_PADDING}px`,
				};
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.selectedIndex = null;
					this.activePanel = '';
					this.syncForm();
				}
			},
			data: {
				deep: true,
				handler() {
					if (this.visible) {
						this.syncForm();
					}
				},
			},
		},
		methods: {
			getEditListSortItemClass,
			normalizeColor(color) {
				return normalizeHexColor(color);
			},
			getCoverUrl(item) {
				return getAudioLibraryCoverUrl(item);
			},
			getAudioUrl(item) {
				return getAudioLibraryAudioUrl(item);
			},
			getSwatchStyle(color) {
				const normalized = normalizeHexColor(color);
				return {
					background: normalized,
					borderColor: getSwatchBorderColor(normalized),
				};
			},
			getPanelAlignClass(index) {
				return getGridPanelAlignClass(index, 3);
			},
			ensureActivePanelVisible() {
				ensureEditFloatPanelVisible(this, {
					wrapSelector: '.g-audio-library-edit__cell-wrap',
					panelSelector: '.g-audio-library-edit__panel--float',
				});
			},
			syncForm() {
				this.form = normalizeAudioLibraryData(this.data);
				this.coverSizeDraft = this.form.coverSize;
				this.cardRadiusDraft = this.form.cardBorderRadius;
				this.coverRadiusDraft = this.form.coverBorderRadius;
				if (
					this.selectedIndex != null
					&& this.selectedIndex >= this.form.items.length
				) {
					this.selectedIndex = null;
				}
			},
			selectItem(index) {
				this.selectedIndex = index;
				this.ensureActivePanelVisible();
			},
			clearSelection() {
				this.selectedIndex = null;
				this.activePanel = '';
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'height') {
					this.coverSizeDraft = this.form.coverSize;
				}
				if (panel === 'cardRadius') {
					this.cardRadiusDraft = this.form.cardBorderRadius;
				}
				if (panel === 'coverRadius') {
					this.coverRadiusDraft = this.form.coverBorderRadius;
				}
				if (this.activePanel) {
					this.ensureActivePanelVisible();
				}
			},
			toggleShowCard() {
				this.form.showCard = !this.form.showCard;
				if (!this.form.showCard && this.activePanel === 'cardRadius') {
					this.activePanel = '';
				}
			},
			addBatch() {
				this.form.items.push(...createDefaultAudioLibraryItems(3));
				this.selectedIndex = this.form.items.length - 3;
			},
			addOne() {
				this.form.items.push(createDefaultAudioLibraryItem({}, this.form.items.length));
				this.selectedIndex = this.form.items.length - 1;
			},
			onItemDragStart(id) {
				handleEditListSortDragStart(this, id);
			},
			onSortDragOver(event) {
				handleEditListSortDragOver(event, this.$refs.editGrid, this);
			},
			onItemDragEnd() {
				handleEditListSortDragEnd(this, this.$refs.editGrid, this.form.items, this, (result) => {
					this.selectedIndex = resolveSelectedIndexAfterListMove(
						this.selectedIndex,
						result.fromIndex,
						result.toIndex,
					);
				});
			},
			deleteItem(index) {
				if (this.form.items.length <= 1) return;
				const removed = this.form.items[index];
				if (removed) {
					revokeAudioLibraryItems([removed]);
				}
				this.form.items.splice(index, 1);
				if (this.selectedIndex === index) {
					this.selectedIndex = null;
					this.activePanel = '';
				} else if (this.selectedIndex != null && this.selectedIndex > index) {
					this.selectedIndex -= 1;
				}
			},
			triggerCoverSelect() {
				this.$refs.coverInput?.click();
			},
			triggerAudioSelect() {
				this.$refs.audioInput?.click();
			},
			async onCoverSelect(event) {
				const file = event.target.files?.[0];
				event.target.value = '';
				if (!file || !isLocalImageFile(file) || !this.selectedItem) return;
				if (file.size > MAX_LOCAL_IMAGE_SIZE) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([file]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [file],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					this.selectedItem.cover = replaceAudioLibraryCover(
						this.selectedItem.cover,
						file,
						() => item,
					);
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			async onAudioSelect(event) {
				const file = event.target.files?.[0];
				event.target.value = '';
				if (!file || !this.selectedItem) return;
				if (!file.type?.startsWith('audio/') && !isAudioFilename(file.name)) return;
				if (file.size > MAX_LOCAL_AUDIO_SIZE) return;
				const [validFile] = filterValidLocalAudioList([file], 1);
				if (!validFile) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([validFile]);
				try {
					const [nextAudio] = await uploadHeaderMediaFiles(this, {
						type: 'audio',
						files: [validFile],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					this.selectedItem.audio = replaceAudioLibraryAudio(this.selectedItem.audio, nextAudio);
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			onAccentColorInput(color) {
				this.form.accentColor = color;
			},
			onTitleColorInput(color) {
				this.form.titleColor = color;
			},
			onNameColorInput(color) {
				this.form.nameColor = color;
			},
			applyCoverSize() {
				this.form.coverSize = Math.max(1, Number(this.coverSizeDraft) || AUDIO_LIBRARY_DEFAULT_COVER_SIZE);
				this.form.coverResponsive = false;
				this.activePanel = '';
			},
			applyCardRadius() {
				this.form.cardBorderRadius = Math.max(0, Number(this.cardRadiusDraft) || 0);
				this.activePanel = '';
			},
			applyCoverRadius() {
				this.form.coverBorderRadius = Math.max(0, Number(this.coverRadiusDraft) || 0);
				this.activePanel = '';
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				const payload = normalizeAudioLibraryData({ ...this.form });
				this.$emit('confirm', payload);
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../styles/edit-float-panel.less';

	.edit-float-panel(g-audio-library-edit__panel);
	.edit-float-toolbar(g-audio-library-edit__toolbar);
	.edit-float-action(g-audio-library-edit__action);

	.g-audio-library-edit {
		min-height: 360px;
		padding: 4px 0 12px;
	}

	.g-audio-library-edit__actions {
		.edit-list-sort-actions-row();
		margin-bottom: 16px;
	}

	.g-audio-library-edit__actions-btns {
		.edit-list-sort-actions-btns();
	}

	.g-audio-library-edit__batch-btn {
		border: none;
		background: transparent;
		padding: 0;
		font-size: 13px;
		color: #285af9;
		cursor: pointer;

		&:hover {
			color: #1d4ed8;
		}
	}

	.g-audio-library-edit__card {
		box-sizing: border-box;
		width: 100%;
		overflow: visible;

		&.is-card {
			background: #fff;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		}
	}

	.g-audio-library-edit__header {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 12px;
	}

	.g-audio-library-edit__accent {
		flex-shrink: 0;
		width: 4px;
		height: 16px;
		border-radius: 2px;
	}

	.g-audio-library-edit__title-input {
		flex: 1;
		min-width: 0;
		border: none;
		background: transparent;
		outline: none;
		padding: 0;
		font-size: 16px;
		font-weight: 600;
		line-height: 1.4;
	}

	.g-audio-library-edit__grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 12px;
		width: 100%;
		overflow: visible;
		box-sizing: border-box;

	}

	.g-audio-library-edit__cell-wrap {
		position: relative;
		z-index: 0;
		overflow: visible;

		&.is-active {
			z-index: 2;
		}
	}

	.g-audio-library-edit__hint {
		.edit-list-sort-hint-text();
	}

	.g-audio-library-edit__cell {
		box-sizing: border-box;
		border: 2px dashed #fff;
		border-radius: 2px;
		cursor: grab;
		text-align: center;

		&:active {
			cursor: grabbing;
		}

		&.is-selected {
			border-color: #285af9;
		}
	}

	.g-audio-library-edit__cover {
		position: relative;
		margin: 0 auto;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 24px;
			color: #bfbfbf;
		}
	}

	.g-audio-library-edit__play {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		margin: -16px 0 0 -16px;
		padding: 0;
		border: none;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.45);
		cursor: pointer;
	}

	.g-audio-library-edit__triangle {
		display: block;
		width: 0;
		height: 0;
		margin-left: 3px;
		border-top: 5px solid transparent;
		border-bottom: 5px solid transparent;
		border-left: 8px solid #fff;
	}

	.g-audio-library-edit__name-input {
		display: block;
		width: 100%;
		margin-top: 8px;
		border: none;
		background: transparent;
		outline: none;
		padding: 0 2px 4px;
		font-size: 12px;
		line-height: 1.4;
		text-align: center;
		box-sizing: border-box;
	}

	.g-audio-library-edit__colors {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-left: 4px;
		flex-shrink: 0;
	}

	.g-audio-library-edit__swatch {
		position: relative;
		width: 18px;
		height: 18px;
		border: 1px solid #d9d9d9;
		border-radius: 2px;
		cursor: pointer;
		flex-shrink: 0;
		overflow: hidden;
	}

	.g-audio-library-edit__color-input {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
		border: none;
		padding: 0;
	}

	.g-audio-library-edit__sub-row {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		gap: 8px;
		padding: 8px 12px 10px;
		border-top: 1px solid #f0f0f0;
		white-space: nowrap;
	}

	.g-audio-library-edit__sub-label {
		font-size: 13px;
		color: #666;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.g-audio-library-edit__sub-input {
		width: 88px;
		flex-shrink: 0;
	}

	.g-audio-library-edit__sub-confirm {
		flex-shrink: 0;
		height: 28px;
		padding: 0 12px;
		border: none;
		border-radius: 4px;
		color: #fff;
		font-size: 12px;
		line-height: 28px;
		white-space: nowrap;
		cursor: pointer;
		background-color: #285af9;
		&:hover {
			background: #3868ff;
		}
	}

	.g-audio-library-edit__sub-default {
		font-size: 12px;
		color: #999;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.g-audio-library-edit__file-input {
		display: none;
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-audio-library-edit-modal {
		.edit-modal-body();
		.edit-modal-scroll();

		.g-audio-library-edit-modal__ok {
			white-space: nowrap;
			flex-shrink: 0;

			&:hover,
			&:focus {
				background: #3868ff;
				border-color: #3868ff;
			}
		}
	}
</style>
